export const CIRX_TOKEN = "cirx-token";
export const CIRX_ANONYMOUS_USER = "cirx-anonymous-user";
export const CIRX_ANONYMOUS_TOKEN_EXPIRATION = 780; // En secondes = 13 minutes
export const CIRX_MODULE = "cirx-module";

/**
 * constante retournée par l'API si la requête ne trouve rien (404)
 */
export const NOT_FOUND = "Not Found";

export const TYPESENSE_TOKEN_KEY_PREFIX = "typesense-token";
